export enum LogLevels {
  ERROR_LEVEL = 'error',
  INFO_LEVEL = 'info',
  DEBUG_LEVEL = 'debug',
}

export const LoggingLevels = {
  [LogLevels.ERROR_LEVEL]: 0,
  [LogLevels.INFO_LEVEL]: 1,
  [LogLevels.DEBUG_LEVEL]: 2,
};
